import moment from 'moment'

export default {
  getPostById: state => id => {
    return state.blog.find(post => post.id === id)
  },
  getFormatedDate: state => date => {
    return {
      day: moment(date).format('DD.MM.YYYY'),
      time: moment(date).format('hh:mm')
    }
  },
  getPublishDate: state => date => moment(date || Date.now()).format('YYYY-MM-DD'),
  getCategoriesWithoutThis: state => title => state.categories.filter( cat => cat.title !== title)
}



// WEBPACK FOOTER //
// ./client/store/getters.js